import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { translations } from "../../translations";

function ProfileAccessibility() {
  const { language, changeLanguage } = useLanguage();
  const [textSize, setTextSize] = useState(1); // 0 = Small, 1 = Medium, 2 = Large

  const sizeValues = ["14px", "16px", "18px"];
  const t = translations[language];

  const sizeLabels = [t.small, t.medium, t.large];

  return (
    <div className="accessibility-panel">
      <div className="accessibility-header">
        <div className="accessibility-header-text">
          <h2 className="accessibility-title">{t.accessibility}</h2>
          <p className="accessibility-subtitle">
            {t.customizeExperience}
          </p>
        </div>
      </div>

      {/* Language Section */}
      <div className="accessibility-section">
        <div className="section-header">
          <h3>{t.preferredLanguage}</h3>
        </div>
        <div className="section-body">
          <div className="form-row">
            <label className="accessibility-label">{t.selectLanguage}</label>
            <select
              className="accessibility-select"
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="en">{t.english}</option>
              <option value="tl">{t.tagalog}</option>
            </select>
          </div>
        </div>
      </div>

      {/* Text Size Section */}
      <div className="accessibility-section">
        <div className="section-header">
          <h3>{t.textSize}</h3>
        </div>
        <div className="section-body">
          <div className="text-size-wrapper">
            <div
              className="text-size-preview"
              style={{ fontSize: sizeValues[textSize] }}
            >
              {t.previewTextSize}
            </div>

            <input
              type="range"
              min="0"
              max="2"
              step="1"
              value={textSize}
              className="text-size-slider"
              style={{
                background: `linear-gradient(to right, #29499d 0%, #29499d ${(textSize / 2) * 100}%, #ddd ${(textSize / 2) * 100}%, #ddd 100%)`,
              }}
              onChange={(e) => setTextSize(Number(e.target.value))}
            />


            <div className="text-size-labels">
              <span>{t.small}</span>
              <span>{t.medium}</span>
              <span>{t.large}</span>
            </div>

            <div className="text-size-current">
              Selected Size: <strong>{sizeLabels[textSize]}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileAccessibility;
